export default {

    movCaixaEntradaManual: {},

}